<!-- 温控器实时读数+控制 -->
<template>
    <div class='container containerBox'>
        <div class="detail-box equient-detail-box">
            <div class="detail-subtitle">基本信息
                <el-button class="fr" style="margin-right:20px;" @click="refresh" size="mini" type="primary" icon="el-icon-refresh" plain>刷新数据</el-button>
            </div>
            <div class="detail-item">
                <el-row :gutter="5">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计序列号：</span><span>{{modelData['device-serial']}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计类型：</span><span>{{modelData['devicetype'] === 1 ? '温控器' : "风柜"}}</span>
                    </el-col>
                     <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计型号：</span><span>{{modelData['device-model']}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>状态：</span><span>{{modelData['status'] === 1 ? '在线' : "离线"}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>风机联动：</span><span>{{modelData['Fanlinkage'] === "On" ? '开机' : "关机"}}</span>
                    </el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>睡眠模式：</span><span>{{modelData['SleepMode']}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>风速：</span><span>{{fmtSpeed(modelData.fanSpeed)}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>风机类型：</span><span>{{modelData['fanType']}}</span>
					</el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>防冻保护：</span><span>{{modelData.frostProtection === "On" ? '开启' : "关闭"}}</span>
                    </el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>按键锁：</span><span>{{fmtKeyLock(modelData.keyBoardlock)}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>语言选择：</span><span>{{modelData['languageSwitch']}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>来电运行方式：</span><span>{{modelData.powerOnOperation === "On" ? '开启' : "关闭"}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>定时开关机：</span><span>{{modelData.powerOnTimer}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>开关机状态：</span><span>{{modelData.powerStatus === "On" ? '开启' : "关闭"}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>室温：</span><span>{{tempchange(modelData.roomTemperature)}}{{modelData.temperatureMode === "C"? "℃":"℉"}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>温度补偿：</span><span>{{tempchange(modelData.roomTemperatureCor)}}{{modelData.temperatureMode === "C"? "℃":"℉"}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>设置温度下限：</span><span>{{tempchange(modelData.roomTemperatureLL)}}{{modelData.temperatureMode === "C"? "℃":"℉"}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>设置温度：</span><span>{{tempchange(modelData.roomTemperatureSp)}}{{modelData.temperatureMode === "C"? "℃":"℉"}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>设置温度上限：</span><span>{{tempchange(modelData.roomTemperatureUL)}}{{modelData.temperatureMode === "C"? "℃":"℉"}}</span>
					</el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>上报事件触发源：</span><span>{{fmtValueOn(modelData.triggerSource)}}</span>
                    </el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					    <span>水阀状态：</span><span>{{modelData.waterValve === "On" ? '开启' : "关闭"}}</span>
					</el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>工作模式：</span><span>{{fmtMode(modelData.workMode)}}</span>
                    </el-col>
                    

                    <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>来电运行方式：</span><span>{{fmtOpAtAcback(modelData.op_at_acback)}}</span>
                    </el-col> -->

                </el-row>
            </div>
            <div class="control-box">
                <div class="control-title">
                    <span>控制参数</span>
                </div>
                <el-form :model="form" status-icon :rules="rules" ref="ruleForm2" label-width="90px" class="ruleForm">
                    <el-form-item label="状态" prop="power_on">
                        <el-select v-model="form.powerStatus" clearable placeholder="请选择" >
                            <el-option
                                  v-for="item in options1"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="风速" prop="speed">
                        <el-select v-model="form.fanSpeed" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模式" prop="mode">
                        <el-select v-model="form.workMode" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
					 <!-- @blur="handleChangeInput('temperature')" -->
                    <el-form-item label="温度设置" prop="temperature">
                        <el-input v-model="form.roomTemperatureSp" 
                           
                            clearable
                            placeholder="请输入温度"></el-input>
                    </el-form-item>
					<el-form-item label="锁定">
						<el-select v-model="locks" multiple placeholder="请选择" @change="changelock">
							<el-option
								v-for="(item,index) in options4"
								:key="index"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>								
<!--                    <el-form-item label="锁定" prop="key_lock">
                        <el-select v-model="form.keyBoardlock" clearable placeholder="请选择">
                            <el-option label="解除锁定" :value="0"></el-option>
                            <el-option label="锁定开关机" :value="1"></el-option>
                            <el-option label="锁定模式" :value="2"></el-option>
                            <el-option label="锁定风速" :value="3"></el-option>
                            <el-option label="锁定温度设置" :value="4"></el-option>
                            <el-option label="锁定所有按键操作" :value="5"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" @click="onResult">确认</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import Service from '@/api/Service'
let Timer;
let COUNT = 1;

export default {
    name:  'equipmentcontrol',
    data() {
        return {
            modelData: {},
			locks:[],
			options1: [{
			          value: 'on',
			          label: '开机'
			        }, {
			          value: 'off',
			          label: '关机'
			        }],
			options2: [{
			          value: 'auto',
			          label: '自动'
			        }, {
			          value: 'high',
			          label: '高风'
			        }, {
			          value: 'medium',
			          label: '中风'
			        }, {
			          value: 'low',
			          label: '低风'
			        }],
			options3: [{
			          value: 'cool',
			          label: '制冷'
			        }, {
			          value: 'fan',
			          label: '通风'
			        }, {
			          value: 'heat',
			          label: '制热'
			        }, {
			          value: 'auto',
			          label: '自动'
			        }],
			options4: [{
			          value: 0,
			          label: '锁定开关机',
			        }, {
			          value: 1,
			          label: '锁定模式',
			        }, {
			          value: 2,
			          label: '锁定风速',
			        }, {
			          value: 3,
			          label: '锁定温度',
			        }, {
			          value: 4,
			          label: '解除锁定'
			        }],		
            form: {
                controlType: 1,
                terminalid: '',
                powerStatus: '',             //  开关机：1
                fanSpeed: '',            //  风速：0
                workMode: '',         //  模式：0
				temperatureMode:'', //温度单位
                roomTemperatureSp: '',        //  设置温度：0
                keyBoardlock:null,          //  按键锁：0
            },
			
            // 参数设置校验
            rules: {},
        };
    },
    components:{
        
    },
    mounted() {
        this.form.terminalid = this.$route.params.terminalid
    },
    destroyed() {
        COUNT = 1;
        clearTimeout(Timer);
    },
    created() {
        this.getInfo(this.$route.params.terminalid)	
    },

    methods: {
		async changelock(val){
			for(var i = 0 ; i<val.length;i++){
				if(val[i] == 4){
					this.locks = [4]
				}
			}
		},
        // 获取表计当前读数
        async getInfo(oid) {
            COUNT++
            Service.getTerminalInfo({oid: oid}).then(data=> {
               if(data) {
                    data = data === 'success' ? [] : data;
                    this.modelData = this.fmtData(data)[0];
					this.form.temperatureMode = this.modelData.temperatureMode
					if(this.modelData.fanType == "WaterFloor"){
						this.options3=[{value: 'Heat',label: '制热'}]
					}
      //               if(COUNT>20) {
      //                   clearTimeout(Timer);
      //                   return
      //               }else{
      //                   Timer = setTimeout(() => {
      //                       this.getInfo(this.$route.params.terminalid);
      //                   }, 5000);
      //               }
                }
            })
        },
        fmtData(data) {
            let arr = data.map(v=>{
                let obj = {}
                obj.oid = v.terminalid;
                obj.devicetype = 1;
                obj["device-model"] = v["device-model"];
                obj["device-serial"] = v["device-serial"];
                obj.status = v.status;
                obj.householdname = v.householdname;
                obj.housename = v.housename;
                let {
                    Fanlinkage,
                    SleepMode,
                    fanSpeed,
                    fanType,
                    frostProtection,
                    keyBoardlock,
                    languageSwitch,
                    powerOnOperation,
                    powerOnTimer,
                    powerStatus,
                    roomTemperature,
                    roomTemperatureCor,
                    roomTemperatureLL,
                    roomTemperatureSp,
                    roomTemperatureUL,
                    temperatureMode,
                    triggerSource,
                    waterValve,
                    workMode,} = v.data;
                    obj = Object.assign(obj,{Fanlinkage,SleepMode,fanSpeed,fanType,frostProtection,keyBoardlock,languageSwitch,powerOnOperation,powerOnTimer,powerStatus,roomTemperature,roomTemperatureCor,roomTemperatureLL, roomTemperatureSp,roomTemperatureUL,temperatureMode,triggerSource,waterValve,workMode,} )      
                    return obj
            })
            return arr
        },
		tempchange(val){
			if(this.modelData.temperatureMode == "C"){
				return val/10
			}else{
				return ((val / 10 * 1.8) + 32).toFixed(1);
			}
		},
        fmtValueOn(valve) {
            if(valve == "Key"){
            	return "按键"
            }else if(valve == "Remote"){
            	return "远程控制"
            }else if(valve == "Timer"){
            	return "定时"
            }else{
            	return ''
            }
        },
        fmtSpeed(speed) {
			if(speed == "Auto"){
				return "自动"
			}else if(speed == "High"){
				return "高风"
			}else if(speed == "Medium"){
				return "中风"
			}else if(speed == "Low"){
				return "低风"
			}else{
				return ''
			}
        },
        fmtMode(mode) {
            if(mode == "COOLING" || mode == "Cool"){
            	return "制冷"
            }else if(mode == "Heat"){
            	return "制热"
            }else if(mode == "Fan"){
            	return "通风"
            }else if(mode == "Auto"){
            	return "自动"
            }else if(mode == "AutoCool"){
            	return "自动制冷"
            }else if(mode == "AutoHeat"){
            	return "自动制热"
            }else{
            	return ''
            }
        },
		
        fmtOpAtAcback(op_at_acback) {
            switch (op_at_acback) {
                case 0:
                    return "保持开机"
                case 1:
                    return "恢复断电前状态"
                case 2:
                    return "强制开机"
                default:
                    return ''
            }
        },
		//处理按键锁模式
        fmtKeyLock(key_lock) {
			key_lock=parseInt(key_lock)
			if(key_lock == 0){
				return "解除锁定"
			}else if(key_lock == 15){
				return "全部锁定"
			}else{
				const str = key_lock.toString(2)
				var strarr = str.split("")
				var lockarr = ["锁定开关机","锁定模式","锁定风速","锁定温度"]
				var keylockstr = ""
				for(var i = 0 ; i < lockarr.length;i++){
					if(strarr[i] == "1"){
						keylockstr = keylockstr + " " + lockarr[i]
					}
				}
				return keylockstr
			}
        },
        handleChangeInput(key, val) {
            let value = this.form[key];
            if(isNaN(value) || value<10 || value>50) {
                this.$message({
                    type: "warn",
                    message: "温度可设置范围10-50;"
                })
                this.form[key] = "";
            }
        },
        async refresh() {
            clearTimeout(Timer);
            await this.getInfo(this.$route.params.terminalid);
            this.$message({
                message: '刷新成功',
                type: 'success'
            });
            COUNT = 1;
        },
        async onResult() {
			COUNT ++
			var templl = this.tempchange(this.modelData.roomTemperatureLL)
			var tempul = this.tempchange(this.modelData.roomTemperatureUL) 
			//控制设置温度的范围
			if(this.form.roomTemperatureSp != ''){
				if(this.form.roomTemperatureSp < templl || this.roomTemperatureSp > tempul){
					this.$message({
						message: '请输入' + templl + '至' + tempul + '范围的温度！',
						type: 'warn'
					});
					return
				}
			}
			this.form.keyBoardlock = null
			for(var i = 0 ; i<this.locks.length;i++){
				var a = Math.pow(2, this.locks[i])
				this.form.keyBoardlock += a
			}
			if(this.form.keyBoardlock >= 16){
				this.form.keyBoardlock = 0
			}
			// this.form.roomTemperatureSp=(this.form.roomTemperatureSp)*10
			
            let form = Object.assign({},this.form);
            let data = await Service.controlmorebytid(form);
            if(data) {
                this.$notify({
                    title: '发送成功',
                    message: '操作指令已下发，由于设备实时状态上报有延迟，请等待页面实时数据刷新。',
                    type: 'success'
                });
                
            }
			if(COUNT>5){
				this.getInfo(this.$route.params.terminalid);
				COUNT = 1;
			}	              
        },
    }
}

</script>
<style lang='less' scoped>
.detail-box{
    margin-right: 300px;
    border-right: 1px solid #ccc;
    position: relative;
    min-height: 600px;
    .detail-subtitle{
        font-size: 16px;
        color: @font-color;
        font-weight: 400;
        margin-bottom: 10px;
    }
    .detail-item{
        border-bottom: 1px solid #ccc;
        margin: 0 20px 10px 0;
        padding: 0 0 20px 20px;
        &.noborder{
            border-bottom: none;
        }
    }
}
.control-box{
    width: 300px;
    position: absolute;
    top: 0;
    right: -300px;
    z-index: 99;
    .control-title{
        font-size: 16px;
        color: #2c3e50;
        font-weight: 400;
        margin-bottom: 10px;
        margin-left: 15px;
        overflow: hidden;
    }
}
</style>
